// extracted by mini-css-extract-plugin
export default {"pending":"fPP7UadYOH4ly4cPgKc0"};